import { useEffect } from "react";

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export function useRecaptcha() {
  useEffect(() => {
    if (!siteKey || window.grecaptcha) return;
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }, []);

  const execute = async (action) => {
    if (!siteKey || !window.grecaptcha) return null;
    return new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(siteKey, { action }).then(resolve).catch(() => resolve(null));
      });
    });
  };

  return { execute, enabled: !!siteKey };
}
